import React, { useState } from 'react'

import List from '../../../components/List'

import { ROUTE_NAME, API_URL } from '../constants'
import { ROUTE_NAME as IncidentDivisionsRouteName } from '../../../incidentDivisions/constants'

import styles from './List.module.css'

const IncidentDivisionList = () => {
  const [divisionId, setDivisionId] = useState(null)

  const divisionColumns = [
    {
      header: 'Name',
      value: (item) => item.name,
      onClick: (item) => setDivisionId(item.id),
    },
    { header: 'Buffers', value: (item) => item.buffers },
  ]

  const bufferColumns = [
    { header: 'Id', value: (item) => item.id },
    {
      header: 'Division',
      value: (item) => item.division.name,
      isLink: true,
    },
    { header: 'AI Layer', value: (item) => item.aiLayer.name },
    { header: 'Distance', value: (item) => item.distance },
    { header: 'Unit', value: (item) => item.unit },
  ]

  return (
    <div className={styles.row}>
      <div className={styles.column}>
        <List
          title="Incident Divisions"
          routeName={IncidentDivisionsRouteName}
          apiUrl={API_URL}
          columns={divisionColumns}
        />
      </div>
      <div className={styles.column}>
        {divisionId && (
          <List
            title="Buffers"
            routeName={ROUTE_NAME}
            apiUrl={`${API_URL}/byDivision/${divisionId}`}
            columns={bufferColumns}
          />
        )}
      </div>
    </div>
  )
}

export default IncidentDivisionList
